import React, { Component } from 'react';
import swal from 'sweetalert';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import * as applicantService from '../../Services/applicantService';
import { withTranslation } from 'react-i18next';

// The code in this class is almost the same as in ApplicationButtons.jsx
class ApplicantButtons extends Component {
  state = { isOpen: false };
  btnSize = this.props.btnSize ? this.props.btnSize : 'xs';
  fontSize = this.props.fontSize ? this.props.fontSize : 'xs';

  changeApplicantStatus = (applicant, newStatus) => {
    const { t } = this.props;
    swal({
      title: t('common.CONFIRMATION_NEEDED'),
      text: t('applicants.CHANGE_APPLICANT_STATE'),
      icon: 'warning',
      buttons: {
        cancel: {
          text: t('common.CANCEL'),
          visible: true,
          closeModal: true,
        },
        confirm: {
          text: t('common.CONFIRM'),
          value: true,
          visible: true,
          closeModal: true,
        },
      },
      dangerMode: true,
    }).then((willChange) => {
      if (willChange) {
        if (newStatus === 'In Progress') {
          newStatus = 'InProgress';
        } else if (newStatus === 'On Hold') {
          newStatus = 'OnHold';
        }

        let tmpId = applicant.applicationId;
        if (!applicant.applicationId) {
          tmpId = applicant.id;
        }

        applicantService.updateApplicantStatus(tmpId, newStatus).then(
          (response) => {
            this.props.onStatusRefresh();
          }
        );
      }
    });
  };

  toggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  composeButtons(applicant) {
    let tempStatus;
    const { t } = this.props;

    if (applicant.status || applicant.status === 0) {
      tempStatus = applicant.status.toString().toLowerCase();
    } else {
      return <div>{t('common.ERROR_NO_STATUS')}</div>;
    }

    if (tempStatus === 'new' || tempStatus === '0') {
      return (
        <ButtonDropdown isOpen={this.state.isOpen} toggle={this.toggle}>
          <DropdownToggle caret size={this.btnSize} style={{ fontSize: this.fontSize }} outline color="success">
            {t('applicants.NEW')}
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={() => this.changeApplicantStatus(applicant, 'In Progress')}>
              <b>{t('applicants.IN_PROGRESS')}</b>
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={() => this.changeApplicantStatus(applicant, 'On Hold')}>
              <b>{t('applicants.ON_HOLD')}</b>
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={() => this.changeApplicantStatus(applicant, 'Hired')}>
              <b>{t('applicants.HIRED')}</b>
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={() => this.changeApplicantStatus(applicant, 'Declined')}>
              <b>{t('applicants.DECLINED')}</b>
            </DropdownItem>
          </DropdownMenu>
        </ButtonDropdown>
      );
    } else if (tempStatus === 'onhold' || tempStatus === '3') {
      return (
        <ButtonDropdown isOpen={this.state.isOpen} toggle={this.toggle}>
          <DropdownToggle caret size={this.btnSize} style={{ fontSize: this.fontSize }} outline color="inverse">
            <b>{t('applicants.ON_HOLD')}</b>
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={() => this.changeApplicantStatus(applicant, 'New')}>
              <b>{t('applicants.NEW')}</b>
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={() => this.changeApplicantStatus(applicant, 'In Progress')}>
              <b>{t('applicants.IN_PROGRESS')}</b>
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={() => this.changeApplicantStatus(applicant, 'Hired')}>
              <b>{t('applicants.HIRED')}</b>
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={() => this.changeApplicantStatus(applicant, 'Declined')}>
              <b>{t('applicants.DECLINED')}</b>
            </DropdownItem>
          </DropdownMenu>
        </ButtonDropdown>
      );
    } else if (tempStatus === 'hired' || tempStatus === '2') {
      return (
        <ButtonDropdown isOpen={this.state.isOpen} toggle={this.toggle}>
          <DropdownToggle caret size={this.btnSize} style={{ fontSize: this.fontSize }} color="purple">
            {t('applicants.HIRED')}
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={() => this.changeApplicantStatus(applicant, 'New')}>
              <b>{t('applicants.NEW')}</b>
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={() => this.changeApplicantStatus(applicant, 'On Hold')}>
              <b>
                <b>{t('applicants.ON_HOLD')}</b>
              </b>
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={() => this.changeApplicantStatus(applicant, 'In Progress')}>
              <b>{t('applicants.IN_PROGRESS')}</b>
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={() => this.changeApplicantStatus(applicant, 'Declined')}>
              <b>{t('applicants.DECLINED')}</b>
            </DropdownItem>
          </DropdownMenu>
        </ButtonDropdown>
      );
    } else if (tempStatus === 'inprogress' || tempStatus === '1') {
      return (
        <ButtonDropdown isOpen={this.state.isOpen} toggle={this.toggle}>
          <DropdownToggle caret size={this.btnSize} style={{ fontSize: this.fontSize }} outline color="primary">
            {t('applicants.IN_PROGRESS')}
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={() => this.changeApplicantStatus(applicant, 'New')}>
              <b>{t('applicants.NEW')}</b>
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={() => this.changeApplicantStatus(applicant, 'On Hold')}>
              <b>
                <b>{t('applicants.ON_HOLD')}</b>
              </b>
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={() => this.changeApplicantStatus(applicant, 'Hired')}>
              <b>{t('applicants.HIRED')}</b>
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={() => this.changeApplicantStatus(applicant, 'Declined')}>
              <b>{t('applicants.DECLINED')}</b>
            </DropdownItem>
          </DropdownMenu>
        </ButtonDropdown>
      );
    } else if (tempStatus === 'declined' || tempStatus === '4' || tempStatus === 'deleted') {
      return (
        <ButtonDropdown isOpen={this.state.isOpen} toggle={this.toggle}>
          <DropdownToggle caret size={this.btnSize} style={{ fontSize: this.fontSize }} outline color="danger">
            {tempStatus === 'declined' || tempStatus === '4' ? t('applicants.DECLINED') : t('applicants.DELETED')}
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={() => this.changeApplicantStatus(applicant, 'New')}>
              <b>{t('applicants.NEW')}</b>
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={() => this.changeApplicantStatus(applicant, 'On Hold')}>
              <b>
                <b>{t('applicants.ON_HOLD')}</b>
              </b>
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={() => this.changeApplicantStatus(applicant, 'In Progress')}>
              <b>{t('applicants.IN_PROGRESS')}</b>
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={() => this.changeApplicantStatus(applicant, 'Hired')}>
              <b>{t('applicants.HIRED')}</b>
            </DropdownItem>
          </DropdownMenu>
        </ButtonDropdown>
      );
    } else {
      return <div></div>;
    }
  }
  render() {
    return this.composeButtons(this.props.applicant);
  }
}

export default withTranslation('translations')(ApplicantButtons);
